var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.664 5.184l-0.544 0.544v10.192l0.016 10.192 0.448 0.448c0.24 0.256 0.72 0.528 1.072 0.624 0.832 0.224 19.040 0.24 20.064 0 0.96-0.208 1.808-0.8 2.128-1.456 0.144-0.288 0.88-1.328 1.648-2.288 1.616-2.032 3.488-4.816 3.92-5.808 0.384-0.88 0.384-1.504 0-1.856-0.272-0.24-1.104-0.256-10.144-0.224l-9.856 0.048-0.48 0.464c-0.272 0.272-0.496 0.544-0.496 0.608 0 0.080-0.864 1.2-1.936 2.496-1.056 1.28-2.32 2.928-2.8 3.616l-0.864 1.28 0.032-6.144 0.048-6.16 19.76-0.080v2.88h2.912l-0.064-1.808c-0.064-2.080-0.272-2.608-1.28-3.28l-0.672-0.432-12.256-0.096v-1.648c0-1.504-0.032-1.664-0.352-1.968-0.736-0.656-0.928-0.688-5.408-0.688h-4.352l-0.544 0.544z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.1b2a9e57.svg";
export { ForwardRef as ReactComponent };